import { css, CSSObject, Interpolation } from "styled-components";

export const sizes: { [key: string]: number } = {
  xs: 0,
  sm: 375,
  sml: 480,
  md: 768,
  mdl: 1024,
  lg: 1280,
  xl: 1920,
};

// Iterate through the sizes and create a media template.
const media = {
  up: Object.keys(sizes).reduce((acc: any, label) => {
    acc[label] = (first: TemplateStringsArray | CSSObject, ...args: Interpolation<object>[]) => css`
      @media (min-width: ${sizes[label]}px) {
        ${css(first, ...args)};
      }
    `;
    return acc;
  }, {}),
  down: Object.keys(sizes).reduce((acc: any, label) => {
    acc[label] = (first: TemplateStringsArray | CSSObject, ...args: Interpolation<object>[]) => css`
      @media (max-width: ${sizes[label]}px) {
        ${css(first, ...args)};
      }
    `;
    return acc;
  }, {}),
};

export default media;
